<template>
  <base-ifp-filter
    label="Spam"
    optionless
    emphasize
    removable
    @close-clicked="handleCloseClick()"
  />
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'IfpFilterSpam',

  emits: ['spam-updated'],

  methods: {
    handleCloseClick() {
      this.$emit('spam-updated', false)
    },
  },
})
</script>
